import { PROXY_IMAGE } from '../../sysconfig';

// logo cũ
export const MISSING_IMAGE_CACHED = `${PROXY_IMAGE}/thuocsi-live/web/static/images/missing.png?size=200`;
// apo-1409: logo mới

export const STORE_IMAGE_DEFAULT_CACHED = `${PROXY_IMAGE}/thuocsi-live/web/static/images/default_store.svg?size=origin`;
export const GIFT_IMAGE_DEFAULT_CACHED = `${PROXY_IMAGE}/thuocsi-live/web/static/images/gift.jpeg?size=origin`;
export const LOGO_MEDX = `${PROXY_IMAGE}/thuocsi-live/web/static/images/logo_medx.png?size=origin`;

export default {
  MISSING_IMAGE_CACHED,
  GIFT_IMAGE_DEFAULT_CACHED,
  STORE_IMAGE_DEFAULT_CACHED,
};
